module.exports = __webpack_public_path__ + "static/img/EC.753e1804.jpg";